export interface IProps {
  type?: PersonnelCardType;
  image?: string;
  fullName?: string;
  occupation?: string;
}
export enum PersonnelCardType {
  Fixed,
  Adaptable,
}
